import React, { useState } from "react";
import { Modal, ModalHeader, ModalFooter, Button } from "shards-react";

const ConfirmationButton = (props) => {
  const [show, setShow] = useState(false);

  function onContinueClick() {
    setShow(false);
    props.onClick();
  }

  function onClick() {
    setShow(true);
  }

  function onCancelClick() {
    setShow(false);
  }
  return (
    <>
      {props.type === "icon" ? (
        <i
          onKeyDown={() => {
            //TODO
          }}
          role="button"
          tabIndex="0"
          {...props}
          onClick={onClick}
        />
      ) : (
        <Button {...props} onClick={onClick} />
      )}

      {show && (
        <Modal
          size="md"
          modalContentClassName="card card-small"
          open={show}
          toggle={() => {}}
        >
          <ModalHeader
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {props.text}
          </ModalHeader>
          <ModalFooter>
            <Button onClick={onCancelClick} theme="danger">
              Cancelar
            </Button>
            <Button
              onClick={onContinueClick}
              theme="success"
              className="ml-1"
              id="confirmation-button-continue"
            >
              Continuar
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};

ConfirmationButton.defaultProps = {
  text: "Tem certeza que deseja continuar?",
};

export default ConfirmationButton;
